module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "untitled-1"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal-310-0-override2"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_c('br', {
    staticClass: "calibre1"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override11"
  }, [_vm._v("For Vincenzo, Roberto, Giovanni, and the entire New England clan, scattered now to time and distance and the four winds ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "calibre_pb_12"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f6ee3d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Dedication.vue
// module id = 72
// module chunks = 0